export default {
  apiUrl: "http://yoursite.com/api/"
};

const siteConfig = {
  siteName: "Previnsight",
  siteIcon: "ion-flash",
  footerText: "Isomorphic ©2017 Created by RedQ, Inc"
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault"
};
const language = "english";
export { siteConfig, language, themeConfig };
